import KYCContainer from './KYCContainer';
export default KYCContainer;